import moment from "moment";

const referralReportColumns = [
  {
    title: 'Record Id',
    dataIndex: 'record_id',
    key: 'record_id',
    render: (text) => {
      return text ?? '-';
    },
    fixed: 'left',
  },
  {
    title: 'Received Date',
    dataIndex: 'created_at',
    key: 'created_at',
    render: (text) => {
      return text ? moment(text).local().format('MM/DD/YYYY hh:mm A') : '-';
    },
    width: 150,
  },
  {
    title: 'Current Status',
    dataIndex: 'current_referral_status',
    key: 'current_referral_status',
    render: (text) => {
      return text ?? '-';
    },
    width: 150,
  },
  {
    title: 'Chart Created',
    dataIndex: 'chart_created',
    key: 'chart_created',
    render: (value) => {
      return value ? 'Yes' : 'No';
    },
    width: 120,
  },
  {
    title: 'Accepted Status Start Time',
    dataIndex: 'accepted_status_start_time',
    key: 'accepted_status_start_time',
    render: (text) => {
      return text ? moment(text).local().format('MM/DD/YYYY hh:mm A') : '-';
    },
    width: 150,
  },
  {
    title: 'Patient Name',
    dataIndex: 'patient_name',
    key: 'patient_name',
    render: (text) => {
      return text ?? '-';
    },
    width: 150,
  },
  {
    title: 'Patient DOB',
    dataIndex: 'patient_dob',
    key: 'patient_dob',
    render: (text) => {
      return text ? moment(text).format('MM/DD/YYYY') : '-';
    },
    width: 150,
  },
  {
    title: 'Days Accepted to Scheduled',
    dataIndex: 'days_accepted_to_scheduled',
    key: 'days_accepted_to_scheduled',
    render: (text) => {
      return text ?? '-';
    },
    width: 150,
  },
  {
    title: 'Days New to Accepted',
    dataIndex: 'days_new_to_accepted',
    key: 'days_new_to_accepted',
    render: (text) => {
      return text ?? '-';
    },
    width: 100,
  },
  {
    title: 'Days New to Scheduled',
    dataIndex: 'days_new_to_scheduled',
    key: 'days_new_to_scheduled',
    render: (text) => {
      return text ?? '-';
    },
    width: 100,
  },
  {
    title: 'Facility Name',
    dataIndex: 'facility_name',
    key: 'facility_name',
    render: (text) => {
      return text ?? '-';
    },
    width: 150,
  },
  {
    title: 'Fax Number',
    dataIndex: 'fax_number',
    key: 'fax_number',
    render: (text) => {
      return text ?? '-';
    },
    width: 150,
  },
  {
    title: 'New Status Start Time',
    dataIndex: 'new_status_start_time',
    key: 'new_status_start_time',
    render: (text) => {
      return text ? moment(text).local().format('MM/DD/YYYY hh:mm A') : '-';
    },
    width: 150,
  },
  {
    title: 'Provider Office',
    dataIndex: 'provider_office',
    key: 'provider_office',
    render: (text) => {
      return text ?? '-';
    },
    width: 150,
  },
  {
    title: 'Referring Provider',
    dataIndex: 'referring_provider',
    key: 'referring_provider',
    render: (text) => {
      return text ?? '-';
    },
    width: 150,
  },
  {
    title: 'Scheduled Status Start Time',
    dataIndex: 'scheduled_status_start_time',
    key: 'scheduled_status_start_time',
    render: (text) => {
      return text ? moment(text).local().format('MM/DD/YYYY hh:mm A') : '-';
    },
    width: 150,
  },
  {
    title: 'Archived',
    dataIndex: 'archived',
    key: 'archived',
    render: (text) => {
      return text ? 'Yes' : 'No';
    },
    width: 90,
  },
];

const statusReportColumns = [
  {
    title: 'Record ID',
    dataIndex: 'record_id',
    key: 'record_id',
    render: (text) => {
      return text ?? '-';
    },
    fixed: 'left',
  },
  {
    title: 'Received Date',
    dataIndex: 'received_date',
    key: 'received_date',
    render: (text) => {
      return text ? moment(text).local().format('MM/DD/YYYY hh:mm A') : '-';
    },
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: (text) => {
      return text ?? '-';
    },
  },
  {
    title: 'Status Change Time',
    dataIndex: 'status_change_time',
    key: 'status_change_time',
    render: (text) => {
      return text ? moment(text).local().format('MM/DD/YYYY hh:mm A') : '-';
    },
  },
  {
    title: 'User',
    dataIndex: 'user_name',
    key: 'user_name',
    render: (text) => {
      return text ?? '-';
    },
  },
  {
    title: 'Patient Name',
    dataIndex: 'patient_name',
    key: 'patient_name',
    render: (text) => {
      return text ?? '-';
    },
  },
  {
    title: 'Patient DOB',
    dataIndex: 'patient_dob',
    key: 'patient_dob',
    render: (text) => {
      return text ? moment(text).format('MM/DD/YYYY') : '-';
    },
  },
  {
    title: 'Current Referral Status',
    dataIndex: 'current_referral_status',
    key: 'current_referral_status',
    render: (text) => {
      return text ?? '-';
    },
  },
  {
    title: 'Current Referral Status Date',
    dataIndex: 'current_referral_status_date',
    key: 'current_referral_status_date',
    render: (text) => {
      return text ? moment(text).format('MM/DD/YYYY') : '-';
    },
  },
  {
    title: 'Referring Provider',
    dataIndex: 'referring_provider',
    key: 'referring_provider',
    render: (text) => {
      return text ?? '-';
    },
  },
  {
    title: 'Provider Office',
    dataIndex: 'provider_office',
    key: 'provider_office',
    render: (text) => {
      return text ?? '-';
    },
  },
  {
    title: 'EMR Category',
    dataIndex: 'emr_category',
    key: 'emr_category',
    render: (text) => {
      return text ?? '-';
    },
  },
  {
    title: 'First Status Change Time',
    dataIndex: 'first_status_change_time',
    key: 'first_status_change_time',
    render: (text) => {
      return text ? moment(text).local().format('MM/DD/YYYY hh:mm A') : '-';
    },
  },
  {
    title: 'Scheduled Status Change Time',
    dataIndex: 'scheduled_status_change_time',
    key: 'scheduled_status_change_time',
    render: (text) => {
      return text ? moment(text).local().format('MM/DD/YYYY hh:mm A') : '-';
    },
  },
  {
    title: 'Recipient',
    dataIndex: 'recipient',
    key: 'recipient',
    render: (text) => {
      return text ?? '-';
    },
  },
  {
    title: 'Department Name',
    dataIndex: 'department_name',
    key: 'department_name',
    render: (text) => {
      return text ?? '-';
    },
  },
  {
    title: 'Archived',
    dataIndex: 'archived',
    key: 'archived',
    render: (text) => {
      return text ?? '-';
    },
  },
];

export {
  referralReportColumns,
  statusReportColumns,
};
